var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompassrose1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 153,
    viewBox: "0 0 155 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.207 11.5C114.943 11.5001 143.914 40.4962 143.914 76.2656C143.914 112.035 114.943 141.031 79.207 141.031C43.4708 141.031 14.5 112.035 14.5 76.2656C14.5001 40.4961 43.4709 11.5 79.207 11.5Z",
    stroke: "#686868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1035 29.5C105.399 29.5 126.707 50.598 126.707 76.6123C126.707 102.626 105.399 123.724 79.1035 123.724C52.8081 123.724 31.5002 102.626 31.5 76.6123C31.5 50.598 52.808 29.5 79.1035 29.5Z",
    stroke: "#686868"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1377 43.5C97.1627 43.5 111.775 58.1256 111.775 76.168C111.775 94.2103 97.1627 108.836 79.1377 108.836C61.1128 108.836 46.5001 94.2102 46.5 76.168C46.5 58.1257 61.1128 43.5001 79.1377 43.5Z",
    stroke: "#686868"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5693 60.5C88.4434 60.5002 95.6377 67.7008 95.6377 76.584C95.6377 85.4672 88.4434 92.6678 79.5693 92.668C70.6951 92.668 63.5 85.4673 63.5 76.584C63.5 67.7007 70.6951 60.5 79.5693 60.5Z",
    stroke: "#686868"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 31L124.862 121.944",
    stroke: "#686868"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 122L124.862 31.0559",
    stroke: "#686868"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79 140V12.0538",
    stroke: "#686868"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 77H144.121",
    stroke: "#686868"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1292 2.016H80.9762V7H80.3042L77.6162 3.507V7H76.7762V2.016H77.4482L80.1292 5.502V2.016Z",
    fill: "#686868"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7699 75.016H9.6379L7.8739 80H7.1389L5.8859 76.416L4.6189 80H3.8839L2.1269 75.016H3.0439L4.2899 78.733L5.5849 75.016H6.2289L7.4959 78.761L8.7699 75.016Z",
    fill: "#686868"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M147.578 80V75.016H150.91V75.73H148.46V77.109H150.763V77.823H148.46V79.286H150.91V80H147.578Z",
    fill: "#686868"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8529 149.364C78.4702 149.364 78.1109 149.312 77.7749 149.21C77.4435 149.107 77.1612 148.96 76.9279 148.769L77.2359 148.111C77.4785 148.293 77.7305 148.428 77.9919 148.517C78.2579 148.601 78.5472 148.643 78.8599 148.643C79.2052 148.643 79.4712 148.582 79.6579 148.461C79.8492 148.339 79.9449 148.169 79.9449 147.95C79.9449 147.763 79.8562 147.621 79.6789 147.523C79.5062 147.42 79.2192 147.324 78.8179 147.236C78.1925 147.1 77.7375 146.925 77.4529 146.711C77.1682 146.496 77.0259 146.183 77.0259 145.773C77.0259 145.479 77.1052 145.217 77.2639 144.989C77.4225 144.76 77.6465 144.58 77.9359 144.45C78.2299 144.319 78.5682 144.254 78.9509 144.254C79.3009 144.254 79.6322 144.307 79.9449 144.415C80.2622 144.517 80.5212 144.662 80.7219 144.849L80.4209 145.507C79.9775 145.152 79.4875 144.975 78.9509 144.975C78.6289 144.975 78.3745 145.042 78.1879 145.178C78.0012 145.308 77.9079 145.488 77.9079 145.717C77.9079 145.913 77.9895 146.062 78.1529 146.165C78.3209 146.267 78.6055 146.363 79.0069 146.452C79.4222 146.55 79.7605 146.657 80.0219 146.774C80.2832 146.886 80.4839 147.033 80.6239 147.215C80.7639 147.392 80.8339 147.616 80.8339 147.887C80.8339 148.185 80.7545 148.447 80.5959 148.671C80.4372 148.89 80.2085 149.06 79.9099 149.182C79.6112 149.303 79.2589 149.364 78.8529 149.364Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassrose1);
export default __webpack_public_path__ + "static/media/compassrose-1.2ab7593569844a1ac59c918a8887ba7e.svg";
export { ForwardRef as ReactComponent };